import styled from 'styled-components'

export const ListViewContainer = styled.div<{ $isVisible: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* height: 100vh; */
  /* max-height: 100vh; */
  background: #fafafa;
  overflow: hidden;
  display: ${(props) => (props.$isVisible ? 'flex' : 'none')};
  flex-direction: column;
  z-index: 10;
  margin: 70px 15px 0px 50px;
`

export const ListHeader = styled.div`
  background: #ffffff;
  border-bottom: 1px solid #e5e5e5;
  padding: 20px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;

  @media (max-width: 768px) {
    padding: 16px;
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }
`

export const ListHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;

  @media (max-width: 768px) {
    justify-content: space-between;
  }
`

export const ResultsCount = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;

  span {
    color: #6b6b6b;
    font-weight: 400;
  }
`

export const ListActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`

export const ActionButton = styled.button<{ $primary?: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: ${(props) => (props.$primary ? '#00ade6' : '#ffffff')};
  border: 1px solid ${(props) => (props.$primary ? '#00ade6' : '#e5e5e5')};
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  color: ${(props) => (props.$primary ? 'white' : '#1a1a1a')};
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  font-family: inherit;

  touch-action: manipulation;
  -webkit-tap-highlight-color: rgba(0, 173, 230, 0.1);

  &:active:not(:disabled) {
    transform: scale(0.95);
    background: ${(props) => (props.$primary ? '#0099cc' : '#e5e5e5')};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover:not(:disabled) {
      background: ${(props) => (props.$primary ? '#00a1d6' : '#f5f5f5')};
      border-color: ${(props) => (props.$primary ? '#00a1d6' : '#6b6b6b')};
    }
  }

  svg {
    width: 16px;
    height: 16px;
    stroke: currentColor;
    stroke-width: 2;
    fill: none;
  }

  @media (max-width: 480px) {
    padding: 6px 12px;
    font-size: 12px;
  }
`

export const ListControls = styled.div`
  background: #ffffff;
  padding: 16px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e5e5e5;
  flex-shrink: 0;

  @media (max-width: 768px) {
    padding: 12px 16px;
  }
`

export const ListControlsLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
`

export const Checkbox = styled.div<{
  $checked?: boolean
  $indeterminate?: boolean
}>`
  width: 18px;
  height: 18px;
  border: 2px solid
    ${(props) =>
      props.$checked || props.$indeterminate ? '#00ade6' : '#e5e5e5'};
  border-radius: 4px;
  background: ${(props) =>
    props.$checked || props.$indeterminate ? '#00ade6' : '#ffffff'};
  cursor: pointer;
  position: relative;
  transition: all 0.2s;
  touch-action: manipulation;
  -webkit-tap-highlight-color: rgba(0, 173, 230, 0.2);

  &:active {
    transform: scale(0.9);
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      border-color: #00ade6;
    }
  }

  ${(props) =>
    props.$checked &&
    `
    &::after {
      content: '';
      position: absolute;
      left: 4px;
      width: 5px;
      height: 9px;
      border: solid white;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }
  `}

  ${(props) =>
    props.$indeterminate &&
    `
    &::after {
      content: '';
      position: absolute;
      left: 4px;
      top: 7px;
      width: 8px;
      height: 2px;
      background: white;
    }
  `}
`

export const SortWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const SortLabel = styled.label`
  font-size: 13px;
  color: #6b6b6b;
`

export const SortSelect = styled.select`
  padding: 6px 32px 6px 12px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  font-size: 13px;
  color: #1a1a1a;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1 1L5 5L9 1' stroke='%236B6B6B' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 12px center;
  transition: all 0.2s;
  font-family: inherit;

  &:focus {
    outline: none;
    border-color: #00ade6;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      border-color: #6b6b6b;
    }
  }
`

export const TableContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  background: #ffffff;
  padding-bottom: 80px;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a1a1a1;
  }

  @media (max-width: 768px) {
    padding: 16px;
    padding-bottom: 100px;

    &::-webkit-scrollbar {
      width: 4px;
    }
  }
`

export const LandTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 8px;

  @media (max-width: 768px) {
    display: none;
  }
`

export const TableHeader = styled.th`
  background: #fafafa;
  padding: 12px;
  text-align: left;
  font-size: 12px;
  font-weight: 500;
  color: #6b6b6b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  position: sticky;
  top: 0;
  z-index: 20;
  border-bottom: 1px solid #e5e5e5;
  min-width: 10%;
  box-shadow: 0 1px 0 0 #e5e5e5;

  &:first-child {
    padding-left: 32px;
    width: 50px;

    @media (max-width: 768px) {
      padding-left: 16px;
    }
  }

  &:last-child {
    padding-right: 32px;

    @media (max-width: 768px) {
      padding-right: 16px;
    }
  }

  @media (max-width: 768px) {
    padding: 8px 12px;
  }
`

export const TableRow = styled.tr<{ $selected?: boolean }>`
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.2s;
  cursor: pointer;
  background: ${(props) => (props.$selected ? '#e6f7fc' : 'transparent')};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background: ${(props) => (props.$selected ? '#e6f7fc' : '#f5f5f5')};
    }
  }
`

export const TableCell = styled.td`
  padding: 12px 8px;
  font-size: 14px;
  color: #1a1a1a;
  min-width: 10%;

  &:first-child {
    padding-left: 32px;

    @media (max-width: 768px) {
      padding-left: 16px;
    }
  }

  &:last-child {
    padding-right: 32px;

    @media (max-width: 768px) {
      padding-right: 16px;
    }
  }

  @media (max-width: 768px) {
    padding: 12px;
    font-size: 13px;
  }
`

export const RadarContainer = styled.div`
  width: 50px;
  height: 50px;
  margin: 0 auto;
`

export const MunicipalityInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const MunicipalityName = styled.div`
  font-weight: 600;
  color: #1a1a1a;
`

export const PlotId = styled.div`
  font-size: 12px;
  color: #6b6b6b;
  font-family: monospace;
`

export const AddressInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const AddressPrimary = styled.div`
  font-weight: 500;
  color: #1a1a1a;
`

export const AddressSecondary = styled.div`
  font-size: 12px;
  color: #6b6b6b;
`

export const BuildingInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const BuildingCount = styled.div`
  font-weight: 600;
  color: #1a1a1a;
`

export const BuildingYear = styled.div`
  font-size: 12px;
  color: #6b6b6b;
`

export const UnitsCount = styled.div`
  font-weight: 600;
  color: #1a1a1a;
`

export const ActivityInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`

export const ActivityTag = styled.div<{ $hasActivity?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  background: ${(props) =>
    props.$hasActivity ? 'rgba(0, 173, 230, 0.1)' : '#f5f5f5'};
  color: ${(props) => (props.$hasActivity ? '#00ade6' : '#6b6b6b')};

  .activity-icon {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
  }
`

export const LandTypeInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const LandTypeMain = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ZoneCode = styled.div`
  font-weight: 600;
  color: #1a1a1a;
  font-size: 13px;
  background: #f5f5f5;
  padding: 2px 6px;
  border-radius: 4px;
`

export const LandType = styled.div`
  font-size: 13px;
  color: #1a1a1a;
`

export const UtilizationInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const UtilizationRate = styled.div<{
  $type: 'success' | 'warning' | 'danger'
}>`
  font-weight: 600;
  font-size: 12px;
  color: ${(props) => {
    switch (props.$type) {
      case 'success':
        return '#00b341'
      case 'warning':
        return '#ff9500'
      case 'danger':
        return '#ff3b30'
      default:
        return '#6b6b6b'
    }
  }};
`

export const ZoneSecondary = styled.div`
  font-size: 11px;
  color: #999999;
`

export const LabelsContainer = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
`

export const Label = styled.div<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  transition: all 0.2s;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
  }

  svg {
    width: 12px;
    height: 12px;
    stroke-width: 2.5;
  }

  ${(props) => {
    const colors = {
      blue: 'background: rgba(0, 173, 230, 0.1); color: #0099cc;',
      green: 'background: rgba(0, 179, 65, 0.1); color: #00994d;',
      purple: 'background: rgba(128, 90, 213, 0.1); color: #7b61ff;',
      orange: 'background: rgba(255, 149, 0, 0.1); color: #ff8800;',
      red: 'background: rgba(255, 59, 48, 0.1); color: #ff3333;',
      yellow: 'background: rgba(255, 204, 0, 0.1); color: #cc9900;',
      teal: 'background: rgba(90, 200, 250, 0.1); color: #00aab8;',
      pink: 'background: rgba(255, 45, 85, 0.1); color: #ff2d55;',
      gray: 'border: 1px solid rgba(142, 142, 147, 0.1); color: #8e8e93;',
    }
    return colors[props.$color as keyof typeof colors] || colors.gray
  }}
`

export const PaginationContainer = styled.div`
  background: #ffffff;
  border-top: 1px solid #e5e5e5;
  padding: 16px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 30;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 12px 16px;
    flex-direction: column;
    gap: 12px;
  }
`

export const RowsPerPage = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`

export const RowsLabel = styled.label`
  font-size: 13px;
  color: #6b6b6b;
`

export const RowsSelect = styled.select`
  padding: 6px 32px 6px 12px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  font-size: 13px;
  color: #1a1a1a;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1 1L5 5L9 1' stroke='%236B6B6B' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 12px center;
  font-family: inherit;
`

export const PaginationInfo = styled.div`
  font-size: 13px;
  color: #6b6b6b;
`

export const PaginationControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const PageButton = styled.button<{ $active?: boolean }>`
  width: 32px;
  height: 32px;
  border: 1px solid ${(props) => (props.$active ? '#00ade6' : '#e5e5e5')};
  background: ${(props) => (props.$active ? '#00ade6' : '#ffffff')};
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  color: ${(props) => (props.$active ? 'white' : '#1a1a1a')};
  font-family: inherit;

  touch-action: manipulation;
  -webkit-tap-highlight-color: rgba(0, 173, 230, 0.1);

  &:active:not(:disabled) {
    transform: scale(0.9);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover:not(:disabled) {
      background: ${(props) => (props.$active ? '#00ade6' : '#f5f5f5')};
      border-color: ${(props) => (props.$active ? '#00ade6' : '#6b6b6b')};
    }
  }

  svg {
    width: 16px;
    height: 16px;
    stroke: currentColor;
    stroke-width: 2;
    fill: none;
  }
`

export const MetricValue = styled.span`
  font-weight: 600;
`

export const MetricUnit = styled.span`
  color: #6b6b6b;
  font-weight: 400;
  margin-left: 4px;
`

// Mobile Card Layout
export const MobileCardsContainer = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`

export const MobilePropertyCard = styled.div<{ $selected?: boolean }>`
  background: ${(props) => (props.$selected ? '#e6f7fc' : '#ffffff')};
  border: 1px solid ${(props) => (props.$selected ? '#00ade6' : '#e5e5e5')};
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s;
  touch-action: manipulation;
  -webkit-tap-highlight-color: rgba(0, 173, 230, 0.1);

  &:active {
    transform: scale(0.98);
    background: ${(props) => (props.$selected ? '#d6f1fb' : '#f8f9fa')};
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      border-color: #00ade6;
      box-shadow: 0 2px 8px rgba(0, 173, 230, 0.1);
    }
  }
`

export const MobileCardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 12px;
`

export const MobileCardMain = styled.div`
  flex: 1;
`

export const MobileCardActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const MobileRadarContainer = styled.div`
  width: 40px;
  height: 40px;
  flex-shrink: 0;
`

export const MobileCardContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 12px;
`

export const MobileCardSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const MobileCardLabel = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: #999999;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

export const MobileCardValue = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #1a1a1a;
`

export const MobileLabelsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 12px;
`

export const MobileActivityRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
`

export const MobileActivityGroup = styled.div`
  display: flex;
  gap: 8px;
`
